












































import { Vue, Component, Prop } from "vue-property-decorator";
import { Property } from "../properties/types";
import { propertiesStore } from "./store";

@Component({
  components: {}
})
export default class PropertyCardView extends Vue {
  @Prop(String) private mother!: string;
  @Prop() private property!: Property;

  propertyDetail = {};
  propertyIDTemp = "";
  motherTemp = "";
  gotoPropertyDetail(property: any) {
    this.$router.push({
      name: "property",
      params: {
        property,
        mother: this.mother,
        propertyID: this.property.id
      }
    });
  }

  get isFromExplore() {
    return this.mother === "Explore";
  }

  beforeMount() {
    // if prop undefined => retrieve property from param
    if (this.property === undefined) {
      const result = propertiesStore.state.items.find(
        property => property.id === this.property.id
      );
      this.propertyDetail = result!;
    } else {
      this.propertyDetail = this.property;
    }
  }
}
